import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { Pane, Button, MenuSection } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useQuery } from "react-query";
import { fetchLibraryById } from "../../api/libraryService";
import { LibraryDetail } from "../../components/library/LibraryDetail";
import { LibraryEmailTemplatesDialog } from "../../components/library/LibraryEmailTemplatesDialog";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { usePermissions } from "../../hooks/usePermissions";
import { libraryEdit } from "../../types/routePaths";
import { useMessageTemplatesDialogParam } from "../../hooks/useMessageTemplatesDialogParam";
var LibraryDetailPage = function () {
    var _a;
    var libraryId = useParams().id;
    var history = useHistory();
    var kyInstance = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var canEditLibraryItem = usePermissions().canEditLibraryItem;
    var emailTemplates = useMessageTemplatesDialogParam();
    var _b = useQuery(["library", libraryId], function () { return fetchLibraryById(kyInstance, libraryId); }, {
        enabled: !!libraryId,
    }), library = _b.data, isLibraryLoading = _b.isLoading, isLibraryError = _b.isError, libraryFetchError = _b.error;
    var handleBackToList = function () {
        history.goBack();
    };
    if (!libraryId) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-legaldeposits.libraries.detail.pane.title",
                }) },
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.error.id.not.provided" })),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.back" })))));
    }
    if (isLibraryLoading) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-legaldeposits.libraries.detail.pane.title",
                }) },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.loading" }))));
    }
    if (isLibraryError || !library) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-legaldeposits.libraries.detail.pane.title",
                }) },
                React.createElement("p", null, (libraryFetchError === null || libraryFetchError === void 0 ? void 0 : libraryFetchError.message) || (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.error.library.not.found" }))),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.back" })))));
    }
    var libraryDisplayName = library.name ||
        formatMessage({ id: "ui-br-legaldeposits.libraries.detail.pane.title" });
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: libraryDisplayName, firstMenu: React.createElement(Button, { buttonStyle: "default", onClick: handleBackToList, marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.back" })), actionMenu: function () { return (React.createElement(MenuSection, { label: formatMessage({
                    id: "ui-br-legaldeposits.action.menu.label",
                }), id: "actions-menu" },
                canEditLibraryItem && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                        history.push(libraryEdit(libraryId));
                    }, fullWidth: true },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.libraries.detail.action.edit" }))),
                canEditLibraryItem && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: emailTemplates.openDialog, fullWidth: true },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.libraries.detail.action.editMessageTemplates" }))))); } },
            React.createElement(LibraryDetail, { library: library })),
        React.createElement(LibraryEmailTemplatesDialog, { open: canEditLibraryItem && emailTemplates.selectedType !== null, onClose: emailTemplates.closeDialog, libraryId: libraryId, libraryName: library.name, selectedType: (_a = emailTemplates.selectedType) !== null && _a !== void 0 ? _a : "URGENCE", onSelectedTypeChange: emailTemplates.setSelectedType })));
};
export default LibraryDetailPage;
